import type { UUID, EpochMs } from './types';

export const newId = (): UUID => crypto.randomUUID();
export const now = (): EpochMs => Date.now();
